export const CUSTOM_OPTIONS_FORM_ID = 'CUSTOM_OPTIONS_FORM_ID'; // eslint-disable-line
export const CUSTOM_OPTIONS_FORM = 'CUSTOM_OPTIONS_FORM';
